import { render } from "./SalesforceLogoIcon.vue?vue&type=template&id=4b9caafb"
import script from "./SalesforceLogoIcon.vue?vue&type=script&lang=js"
export * from "./SalesforceLogoIcon.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/flydata-next/flydata-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__